import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import
    {
        ApiHandlerDiscreteParameter,
        createHandlerChainRunner,
        HasOnError,
        HasOnSuccess
    } from "@insite/client-framework/HandlerCreator";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import
    {
        AddCartWishListApiParameter,
        addSharedWishList
    } from "@MasterBluePrint/Services/ShareCartListService";

type AddCartWishListParameter = {
    wishListLines: ProductInfo[];
    cartId?: string;
    name?: string;
    senderName?: string;
    senderEmail?: string;
    recipientEmail?: string;
    description?: string;
    isSharedCart?: string;
} & HasOnSuccess<any> & HasOnError;



type HandlerType = ApiHandlerDiscreteParameter<AddCartWishListParameter, AddCartWishListApiParameter, WishListModel>;
export const SendDataToApi: HandlerType = async props => {
    try
    {
        
    props.apiResult =  await addSharedWishList({
            wishListLines: props.parameter.wishListLines,        
            name: `${props.parameter.name}`,
            senderName: `${props.parameter.senderName}`,
            senderEmail: `${props.parameter.senderEmail}`,
            recipientEmail: `${props.parameter.recipientEmail}`,
            description: `${props.parameter.description}`,
            isSharedCart: props.parameter.senderName,
    });
    props.parameter.onSuccess?.(props.apiResult);
    } catch {
    props.parameter.onSuccess?.(false);
    }
};



export const chain = [ SendDataToApi];


const shareCart = createHandlerChainRunner(chain, "ShareCart");
export default shareCart;
